import BankAddedLogo from "../../assets/icons/loan_application_page/bank_added.svg";
import BankFailedLogo from "../../assets/icons/loan_application_page/bank_failed.svg";
import BankProcessingLogo from "../../assets/icons/loan_application_page/bank_processing.svg";
import CancelledLogo from "../../assets/icons/common/cancelled.svg";
import ClosedLogo from "../../assets/icons/loan_application_page/closed.svg";
import DisbursedLogo from "../../assets/icons/loan_application_page/disbursed.svg";
import FreshLoanLogo from "../../assets/icons/loan_application_page/fresh_loan.svg";
import KycProcessingLogo from "../../assets/icons/loan_application_page/kyc_processing.svg";
import KycSuccessLogo from "../../assets/icons/loan_application_page/kyc_success.svg";
import KycRejectedLogo from "../../assets/icons/loan_application_page/kyc_rejected.svg";
import LoanApprovedLogo from "../../assets/icons/loan_application_page/loan_approved.svg";
import DetailsSubmittedLogo from "../../assets/icons/loan_application_page/loan_details_submitted.svg";
import LoanRejectedLogo from "../../assets/icons/loan_application_page/loan_rejected.svg";
import SignAgreementLogo from "../../assets/icons/loan_application_page/sign_agreement.svg";

import ApplicationStartedLogo from "../../assets/icons/leads_page/application_started.svg";
import DisqualifiedLogo from "../../assets/icons/leads/disqualified.svg";
import NewUserLogo from "../../assets/icons/leads/new_user.svg";
import ProfileUpdatedLogo from "../../assets/icons/leads/profile_updated.svg";
import QualifiedLogo from "../../assets/icons/leads/qualified.svg";
import TotalLeadsLogo from "../../assets/icons/leads/total_leads.svg";
import UnderReviewLogo from "../../assets/icons/leads_page/under_review.svg";

import PaidLogo from "../../assets/icons/creditline/paid_2.svg";
import UnpaidLogo from "../../assets/icons/creditline/unpaid.svg";
import PartiallyPaidLogo from "../../assets/icons/creditline/partially_paid.svg";
import OverdueLogo from "../../assets/icons/creditline/overdue_2.svg";
import AllStagesLogo from "../../assets/icons/common/all_stages_2.svg";
import {
  pflDomains,
  pflStyling,
  hfclStyling,
  hfclDomains
} from "./ThemeConfig";

export const TODO_MESSAGES = {
  DUPLICATE_HIERARCHY_NAME:
    "TODO Future use-case: If we have multiple objects in response of USERS_INFO_V2 with same values of hierarchyName, we would need to update here"
} as const;

export const SOURCES = {
  IIFLID: "b46205ae-14f3-43ae-bedb-86d4d82df2f8",
  IIFLBLID: "488ca8e9-b821-4502-b4f0-a0c0a6d02fb1",
  FINBOXID: "7ae9ddeb-85d1-4dfa-a8c9-2662a3663c29",
  ABFLID: "c1a55e53-4701-49a1-923c-3cf32a66b5ec"
} as const;

export const EMAIL_LABEL = {
  EMPLOYEE_ID: "Employee ID",
  EMAIL_ADDRESS: "Email address"
};

export const ACCESS_OBJECT = {
  USERS: "dashboardUser" as const,
  APPLICATIONS: "applications" as const,
  KYC: "kyc" as const,
  TXN: "txn" as const,
  INTEGRATION: "integration" as const,
  SETTINGS: "settings" as const
};

export const ACCESS_PERM = {
  VIEW: "view" as const,
  LIST: "list" as const,
  EDIT: "edit" as const,
  DELETE: "delete" as const
};

export const ORANGE = {
  background: "#FFE4B5",
  color: "#FF8C00"
};

export const GREEN = {
  background: "rgb(229, 249, 239)",
  color: "rgb(20 188 107)"
};

export const RED = {
  background: "rgb(253, 235, 235)",
  color: "rgb(235, 87, 87)"
};

export const GREY = {
  background: "rgb(222, 222, 222)",
  color: "rgb(60, 60, 60)"
};

export const BLUE = {
  background: "rgb(226, 244, 253)",
  color: "rgb(17, 161, 241)"
};

export const PENDING_THEME = {
  background: "rgb(243, 244, 246)",
  color: "rgb(107, 114, 128)"
};

export const LOAN_TABS = [
  {
    name: "Details"
  },
  {
    name: "Activity History"
  },
  {
    name: "Application Form"
  },
  {
    name: "KYC"
  },
  {
    name: "Loan Offer"
  },
  {
    name: "Bank Info"
  },
  {
    name: "Partner Details"
  },
  {
    name: "Payments"
  },
  {
    name: "Deviation"
  },
  // {
  //   name: "Bank Statements",
  // },
  {
    name: "Additional Docs"
  },
  {
    name: "Notes"
  }
];

export const PASSWORD_POLICY_KEY = "password-policy";

export const CREDITLINE_TABS = [
  {
    name: "Details"
  },
  {
    name: "Activity History"
  },
  {
    name: "CreditLine Details"
  },
  {
    name: "Application Form"
  },
  {
    name: "KYC"
  },
  {
    name: "CreditLine Transactions"
  },
  {
    name: "Bank Info"
  },
  {
    name: "Partner Details"
  },
  {
    name: "Payments"
  },
  // {
  //   name: "Bank Statements",
  // },
  {
    name: "Additional Docs"
  },
  {
    name: "Notes"
  }
];

export const BUSINESS_LOAN_TABS = [{ name: "Business Details" }];

export const DOCUMENT_TYPES = [
  "Bank statement",
  "Passbook photo",
  "Cancelled cheque"
];

export const LEAD_SEARCH_TYPES = [
  {
    name: "Mobile",
    value: "mobile"
  },
  {
    name: "Name",
    value: "name"
  },
  {
    name: "Customer ID",
    value: "customerID"
  },
  {
    name: "PAN",
    value: "pan"
  },
  {
    name: "Email",
    value: "email"
  },
  {
    name: "Partner Code",
    value: "partnerCode"
  },
  {
    name: "Firm Name",
    value: "firmName"
  },
  {
    name: "Source",
    value: "source"
  },
  {
    name: "CRM ID",
    value: "crmID"
  }
];

export const LOAN_APPLICATION_SEARCH_TYPES = [
  {
    name: "Mobile",
    value: "mobile"
  },
  {
    name: "Name",
    value: "name"
  },
  {
    name: "Customer ID",
    value: "customerID"
  },
  {
    name: "Loan Application ID",
    value: "loanApplicationNum"
  },
  {
    name: "Email",
    value: "email"
  },
  {
    name: "Partner Code",
    value: "partnerCode"
  }
];

export const PARTNER_NAME_ERROR_TYPES = {
  validate: "invalid agent name",
  required: "required"
};

export const MOBILE_ERROR_TYPES = {
  validate: "mobile number must have 10 digits",
  required: "required"
};
export const businessTypes = [
  "Proprietorship",
  "Partnership",
  "Private Limited",
  "Public Limited"
];

export enum PartnerSearchType {
  MOBILE = "mobile",
  EMAIL = "email",
  PARTNER_CODE = "partnerCode",
  PARTNER_NAME = "partnerName",
  DEFAULT = ""
}

export const PartnerTypeValueMap = [
  {
    name: "Mobile",
    value: PartnerSearchType.MOBILE
  },
  {
    name: "Email",
    value: PartnerSearchType.EMAIL
  },
  {
    name: "Agent Code",
    value: PartnerSearchType.PARTNER_CODE
  },
  {
    name: "Agent Name",
    value: PartnerSearchType.PARTNER_NAME
  }
];

export const USER_STAGE_FILTER_COUNTS = {
  total: 0,
  user_created: 0,
  user_token_issued: 0,
  user_profile_updated: 0,
  user_under_review: 0,
  user_qualified: 0,
  user_disqualified: 0,
  user_expired: 0
};

export const USER_STAGE_FILTERS = {
  total: {
    value: 0,
    label: "All Stages",
    icon: TotalLeadsLogo,
    isSelected: true
  },
  user_created: {
    value: 0,
    label: "Created",
    color: "#11A1F1",
    bg: "#E2F4FD",
    icon: NewUserLogo,
    theme: BLUE,
    isSelected: false
  },
  user_token_issued: {
    value: 0,
    label: "Journey Started",
    color: "#11A1F1",
    bg: "#E2F4FD",
    icon: ApplicationStartedLogo,
    theme: BLUE,
    isSelected: false
  },
  user_profile_updated: {
    value: 0,
    label: "Profile Updated",
    color: "#24ca7a",
    bg: "#e5f9ef",
    icon: ProfileUpdatedLogo,
    theme: BLUE,
    isSelected: false
  },
  user_under_review: {
    value: 0,
    label: "Under Review",
    color: "#E7B10A",
    bg: "#FBF0B2",
    icon: UnderReviewLogo,
    theme: BLUE,
    isSelected: false
  },
  user_qualified: {
    value: 0,
    color: "#24ca7a",
    bg: "#e5f9ef",
    label: "User Qualified",
    icon: QualifiedLogo,
    theme: GREEN,
    isSelected: false
  },
  user_disqualified: {
    value: 0,
    label: "Disqualified",
    color: "#eb5757",
    bg: "#fdebeb",
    icon: DisqualifiedLogo,
    theme: RED,
    isSelected: false
  },
  user_expired: {
    value: 0,
    label: "Expired",
    color: "#eb5757",
    bg: "#fdebeb",
    icon: DisqualifiedLogo,
    theme: RED,
    isSelected: false
  }
};

export const OVERDRAFT_STAGE_FILTERS = {
  total: {
    value: 0,
    label: "All Stages",
    icon: AllStagesLogo
  },
  unpaid: {
    value: 0,
    label: "Unpaid",
    icon: UnpaidLogo,
    theme: RED
  },
  paid: {
    value: 0,
    label: "Paid",
    icon: PaidLogo,
    theme: GREEN
  },
  partial: {
    value: 0,
    label: "Partial Paid",
    icon: PartiallyPaidLogo,
    theme: BLUE
  },
  overdue: {
    value: 0,
    label: "Overdue",
    icon: OverdueLogo,
    theme: RED
  }
};

// Red - Disqualified, Cancelled, KYC rejected, Rejected, Bank Failed
// rgb(235, 87, 87); Color
// rgb(253, 235, 235); Background

// Green - Approved, Bank Added, Sign Agreement, Disbursed, KYC Success
// rgb(36, 202, 122); Color

// rgb(229, 249, 239); Background
// Blue - Fresh, Details Submitted, Bank Processing,
// rgb(226, 244, 253);Background
// rgb(17, 161, 241); Color (edited)

// 10:58
// Grey - Closed
// rgb(60, 60, 60); Color
// rgb(222, 222, 222); Background (edited)

export const LOAN_STAGE_FILTER_COUNTS = {
  total: 0,
  fresh_loan: 0,
  cancelled: 0,
  loan_details_submitted: 0,
  kyc_rejected: 0,
  kyc_processing: 0,
  kyc_success: 0,
  under_review: 0,
  loan_rejected: 0,
  loan_approved: 0,
  bank_failed: 0,
  bank_processing: 0,
  bank_added: 0,
  sign_agreement: 0,
  disbursed: 0,
  closed: 0
};

export const LOAN_STAGE_FILTERS = {
  total: {
    value: 0,
    label: "All Stages",
    icon: AllStagesLogo,
    isSelected: true
  },
  fresh_loan: {
    value: 0,
    label: "Fresh Loan",
    icon: FreshLoanLogo,
    theme: BLUE,
    isSelected: false
  },
  cancelled: {
    value: 0,
    label: "Cancelled",
    icon: CancelledLogo,
    theme: RED,
    isSelected: false
  },
  loan_details_submitted: {
    value: 0,
    label: "Details Submitted",
    icon: DetailsSubmittedLogo,
    theme: BLUE,
    isSelected: false
  },
  kyc_rejected: {
    value: 0,
    label: "KYC Rejected",
    icon: KycRejectedLogo,
    theme: RED,
    isSelected: false
  },
  kyc_processing: {
    value: 0,
    label: "KYC Processing",
    icon: KycProcessingLogo,
    theme: BLUE,
    isSelected: false
  },
  kyc_success: {
    value: 0,
    label: "KYC Success",
    icon: KycSuccessLogo,
    theme: GREEN,
    isSelected: false
  },
  under_review: {
    value: 0,
    label: "Under Review",
    icon: KycSuccessLogo,
    theme: BLUE,
    isSelected: false
  },
  loan_rejected: {
    value: 0,
    label: "Loan Rejected",
    icon: LoanRejectedLogo,
    theme: RED,
    isSelected: false
  },
  loan_approved: {
    value: 0,
    label: "Loan Approved",
    icon: LoanApprovedLogo,
    theme: GREEN,
    isSelected: false
  },
  bank_failed: {
    value: 0,
    label: "Bank Failed",
    icon: BankFailedLogo,
    theme: RED,
    isSelected: false
  },
  bank_processing: {
    value: 0,
    label: "Bank Processing",
    icon: BankProcessingLogo,
    theme: BLUE,
    isSelected: false
  },
  bank_added: {
    value: 0,
    label: "Bank Added",
    icon: BankAddedLogo,
    theme: GREEN,
    isSelected: false
  },
  pre_agreement: {
    value: 0,
    label: "Pre-Agreement",
    icon: FreshLoanLogo,
    theme: ORANGE
  },
  sign_agreement: {
    value: 0,
    label: "Sign Agreement",
    icon: SignAgreementLogo,
    theme: GREEN,
    isSelected: false
  },
  disbursed: {
    value: 0,
    label: "Disbursed",
    icon: DisbursedLogo,
    theme: GREEN,
    isSelected: false
  },
  closed: {
    value: 0,
    label: "Closed",
    icon: ClosedLogo,
    theme: GREY,
    isSelected: false
  },
  doc_review: {
    value: 0,
    label: "Document Review",
    icon: DetailsSubmittedLogo,
    theme: BLUE
  },
  vkyc: {
    value: 0,
    label: "VKYC",
    icon: ProfileUpdatedLogo,
    theme: BLUE
  },
  vpd: {
    value: 0,
    label: "VPD",
    icon: DetailsSubmittedLogo,
    theme: GREEN
  }
  // address_verification_queue: {
  //   value: 0,
  //   label: "Address Verification Queue",
  //   icon: "",
  // },
};

export const STAGE_FILTERS: Record<string, any> = {
  pending: {
    value: 0,
    label: "Pending",
    // icon: PendingLogo,
    // theme: PENDING_THEME,
    theme: GREY
  },
  completed: {
    value: 0,
    label: "Completed",
    // icon: CompletedLogo,
    theme: GREEN
  },
  disbursed: {
    value: 0,
    label: "Disbursed",
    // icon: CompletedLogo,
    theme: GREEN
  },
  failed: {
    value: 0,
    label: "Failed",
    // icon: FailedLogo,
    theme: RED
  },
  assigned: {
    value: 0,
    label: "Assigned",
    // icon: AssignedLogo,
    theme: BLUE
  },
  approved: {
    value: 0,
    label: "Approved",
    // icon: ApprovedLogo,
    theme: GREEN
  },
  unstarted: {
    value: 0,
    label: "Unstarted",
    // icon: UnstartedLogo,
    theme: GREY
  },
  initiated: {
    value: 0,
    label: "Initiated",
    // icon: InitiatedLogo,
    theme: BLUE
  },
  hold: {
    value: 0,
    label: "Hold",
    // icon: HoldLogo,
    theme: GREY
  },
  FormSubmitted: {
    value: 0,
    label: "Form Submitted",
    // icon: FormSubmittedLogo,
    theme: BLUE
  },
  lender_initiated: {
    value: 0,
    label: "Lender Initiated",
    // icon: LenderInitiatedLogo,
    theme: BLUE
  },
  pending_on_co: {
    value: 0,
    label: "Pending on CO",
    // icon: PendingOnCOLogo,
    theme: BLUE
  },
  pending_on_bpo: {
    value: 0,
    label: "Pending on BPO",
    // icon: PendingOnBPOLogo,
    theme: BLUE
  },
  pending_on_ops: {
    value: 0,
    label: "Pending on Ops",
    // icon: PendingOnOpsLogo,
    theme: BLUE
  }
};

export const PRODUCT_TYPES = [
  {
    label: "Business Loan",
    type: "productType",
    name: "business_loan",
    isChecked: false,
    value: "business_loan"
  },
  {
    label: "Personal Loan",
    type: "productType",
    name: "personal_loan",
    isChecked: false,
    value: "personal_loan"
  },
  {
    label: "Credit Line",
    type: "productType",
    name: "credit_line",
    isChecked: false,
    value: "credit_line"
  },
  {
    label: "Overdraft",
    type: "productType",
    name: "overdraft",
    isChecked: false,
    value: "overdraft"
  }
];

export const GET_SE_LIST_OBJECTS = {
  users: "user" as const,
  applications: "application" as const,
  kyc: "kyc" as const,
  txn: "transaction" as const,
  settings: "settings" as const,
  integration: "integration" as const
};

export const CONSTITUTION_TYPES = [
  {
    label: "Proprietorship",
    type: "constitution",
    name: "Proprietorship",
    isChecked: false,
    value: "Proprietorship"
  },
  {
    label: "Partnership",
    type: "constitution",
    name: "Partnership",
    isChecked: false,
    value: "Partnership"
  },
  {
    label: "Private Limited",
    type: "constitution",
    name: "Private Limited",
    isChecked: false,
    value: "Private Limited"
  },
  {
    label: "Public Limited",
    type: "constitution",
    name: "Public Limited",
    isChecked: false,
    value: "Public Limited"
  }
];

export const PLATFORMS_LIST = {
  MuthootCL: "ad97435f-af0b-4bed-849e-1b309f943087"
};

export const NO_HEADERS_RESPONSE = {
  data: null,
  error: "No headers set for this action",
  status: false
};

export const PAGES_LIST = {
  LOAN_APPLICATION_DIRECTOR_TAB: "Loan Application Director Tab",
  LOAN_APPLICATION_VERIFICATION_VKYC_TAB:
    "Loan Application Verification VKYC Tab",
  LOAN_APPLICATION_VERIFICATION_VPD_TAB:
    "Loan Application Verification VPD Tab",
  CO_APPLICANT_DETAILS_PAGE: "CoApplicant Details Page",
  LOAN_APPLICATIONS_LISTING_PAGE: "Loan Application Page",
  LOAN_APPLICATION_DETAILS_PAGE: "Loan Application Details Page",
  LOAN_APPLICATION_DETAILS_TAB: "Loan Application Details Tab",
  LOAN_APPLICATION_TIMELINE_TAB: "Loan Application Timeline Tab",
  LOAN_APPLICATION_FORM_TAB: "Loan Application Application Form Tab",
  LOAN_APPLICATION_KYC_TAB: "Loan Application KYC Tab",
  LOAN_APPLICATION_LOAN_OFFER_TAB: "Loan Application Loan Offer Tab",
  LOAN_APPLICATION_CREDITLINE_DETAILS_TAB:
    "Loan Application Creditline Details Tab",
  LOAN_APPLICATION_CREDITLINE_TRANSACTIONS_TAB:
    "Loan Application Creditline Transactions Tab",
  LOAN_APPLICATION_BANK_INFO_TAB: "Loan Application Bank Info Tab",
  LOAN_APPLICATION_PARTNER_INFO_TAB: "Loan Application Partner Details Tab",
  LOAN_APPLICATION_PAYMENTS_TAB: "Loan Application Payments Tab",
  LOAN_APPLICATION_BANK_STATEMENTS_TAB: "Loan Application Bank Statements Tab",
  LOAN_APPLICATION_BUSINESS_DETAILS_TAB:
    "Loan Application Business Details Tab",
  LOAN_APPLICATION_CHECKLIST_TAB: "Loan Application Checklist Tab",
  LOAN_APPLICATION_ADDITIONAL_DOCS_TAB:
    "Loan Application Additional Documents Tab",
  LOAN_APPLICATION_NOTES_TAB: "Loan Application Notes Tab",
  LOAN_APPLICATION_CASE_STATUS_TAB: "Loan Application Case Status Tab",
  LOAN_APPLICATION_LOAN_TERM_DEVIATION_TAB:
    "Loan Application Loan Term Deviation Tab",
  LOAN_APPLICATION_WORKFLOW_TIMELINE_TAB:
    "Loan Application Workflow Timeline Tab",
  LOAN_APPLICATION_DEVIATION_TAB: "Loan Application Deviation Tab",
  LEADS_LISTING_PAGE: "Leads Page",
  LEAD_DETAILS_PAGE: "Leads Details Page",
  LEAD_DETAILS_TAB: "Leads Details Tab",
  LEAD_TIMELINE_TAB: "Leads Timeline Tab",
  LEADS_CASE_STATUS_TAB: "Leads Case Status Tab",
  LEAD_PARTNER_DETAILS_TAB: "Leads Partner Details Tab",
  LEAD_BUSINESS_DETAILS_TAB: "Leads Business Details Tab",
  LEAD_BANK_STATEMENTS_TAB: "Leads Bank Statements Tab",
  LOAN_APPLICATION_SANCTION_CONDITION_TAB:
    "Loan Application Sanction Condition Tab",
  LOAN_APPLICATION_UNDERWRITING_HUNTER_TAB:
    "Loan Application Underwriting Hunter Tab",
  LOAN_APPLICATION_MOVE_TO_SALES_TAB: "Loan Application Move to Sales Tab",
  CREATE_AGENT_PAGE: "Create Agent Page",
  CHOOSE_PARTNER_PAGE: "Choose Partner Page",
  PARTNERS_PAGE: "Partners Page",
  MOBILE_HOME_PAGE: "Mobile Home Page",
  MEMBERS_PAGE: "Members Page",
  ADMIN_PAGE: "Admin Page",
  ADMIN_POLICY_MANAGEMENT_TAB: "Admin Policy Management Tab",
  ADMIN_USER_MANAGEMENT_TAB: "Admin User Management Tab",
  THEME_CONFIG_SETTINGS_TAB: "Integrations Page Themes Tab",
  CREDITLINK_SETTINGS_TAB: "Integrations Page Credit Link Tab",
  API_INTEGRATION_SETTINGS_TAB: "Integrations Page Integrations Tab",
  INTEGRATIONS_PAGE: "Integrations Page",
  OVERDRAFT_LISTING_PAGE: "Overdraft Bills Page",
  ACTIVELINE_LISTING_PAGE: "Creditline Active Lines Page",
  USER_PROFILE_PAGE: "User Profile Page",
  ALL_TRANSACTIONS_LISTING_PAGE: "Creditline All Transactions Page",
  CREATE_NEW_LEAD_PAGE: "Create New Lead Page",
  REPORTS_PAGE: "Reports Page",
  UTILITIES_PAGE: "Utilities Page",
  ANALYTICS_PAGE: "Analytics Page",
  LOAN_APPLICATION_VERIFICATION_PD_TAB: "Loan Application Verification PD Tab",
  LOAN_APPLICATION_DISBURSEMENT_TAB: "Loan Application Disbursement Tab",
  VERIFICATION_QUANTIFIC_TAB: "Loan Application Verification Quantific Tab",
  LOAN_APPLICATIONS_VERIFICATION_KHOJ_TAB:
    "Loan Application Verification Khoj Tab",
  MY_QUEUE: "My Queue Page",
  LOAN_APPLICATION_INSURANCE_TAB: "Loan Application Insurance Tab",
  BANK_INFO_TAB_UI_CONFIG_NAME: "Loan Application Bank Info UI Config Tab",
  LOAN_APPLICATION_NEUROFIN_VERIFICATIONS_TAB:
    "Loan Application Neurofin Verifications Tab",
  LOAN_APPLICATION_DISBURSEMENTS_TAB: "Loan Application Disbursements Tab"
} as const;

export const ACTIONS_LIST = {
  UPDATE_FIELD_INVESTIGATION_DETAILS: "Update Field Investigation Details",
  TRIGGER_FIELD_INVESTIGATION: "Trigger Field Investigation",
  MARK_NACH_SUCCCESS: "Mark NACH Success",
  CREATE_COAPPLICANT: "Create CoApplicant",
  UPDATE_COAPPLICANT: "Update CoApplicant",
  UPDATE_USER_METADATA: "Update User Metadata",
  UPDATE_RELATION_MANAGER_DETAILS: "Update Relation Manager Details",
  APPROVE_KYC: "Approve KYC",
  APPROVE_LOAN: "Approve Loan",
  UPDATE_AGGREGATE_EXPOSURE: "Update LEI",
  MUTHOOT_REGENERATE_KYC_DOCS: "Muthoot Regenerate KYC Docs",
  REJECT_KYC: "Reject KYC",
  CANCEL_EKYC: "Cancel EKYC",
  REJECT_LOAN: "Reject Loan",
  REJECT_MANAUL_CREDIT_REVIEW: "Reject Manual Credit Review",
  APPROVE_MANUAL_CREDIT_REVIEW: "Approve Manual Credit Review",
  UPDATE_KYC_DOC_LENDER: "Update KYC Doc",
  REGENERATE_KYC_ZIP: "Regenerate KYC Zip",
  UPDATE_ADDITIONAL_KYC_DOC: "Update Additional KYC Doc",
  PUSH_ADDITIONAL_DOCUMENT: "Push Additional Document",
  CATEGORY_DROPDOWN: "Category Dropdown",
  MANUAL_APPROVE_BANK_DETAILS: "Manual Approve Bank Details",
  REJECT_DOCUMENT: "Reject Document",
  CANCEL_APPLICATION: "Cancel Application",
  UPDATE_BANK_ACCOUNT_TYPE: "Update Bank Account Type",
  LENDER_UPDATE_BANK_ACCOUNT_TYPE: "Update BankAccountType",
  LENDER_UPDATE_BANK_DETAILS: "Update BankDetails",
  MANUAL_PENNY_DROP: "Manual Penny Drop",
  DOWNLOAD_AUTHENTICATION_LETTER: "Download Authentication Letter",
  DOWNLOAD_SIGNED_AGREEMENT: "Download Signed Agreement",
  DOWNLOAD_UNSIGNED_AGREEMENT: "Download Unsigned Agreement",
  DOWNLOAD_CIBIL_PDF_REPORT: "Download CIBIL PDF report",
  ADD_REFERENCES_FOR_USER: "Add References For User",
  DOWNLOAD_CIBIL_EXCEL_REPORT: "Cibil Reports Excel",
  DOWNLOAD_STATEMENT_OF_ACCOUNTS: "Download Statement of Accounts",
  SEND_AGREEMENT_TO_LENDER: "Send Agreement to Lender",
  REVOKE_DELETE_REQUEST: "Revoke Delete Request",
  RESUME_JOURNEY: "Resume Journey",
  INITIATE_VKYC: "Initiate VKYC",
  EDIT_NAME: "Edit Name",
  UPDATE_NAME: "Update Name",
  UDPATE_ABFL_PL_INDUSTRY_DETAILS: "Update Business Industry Details",
  EDIT_FATHERS_NAME: "Edit Fathers Name",
  UPDATE_FATHERS_NAME: "Update Fathers Name",
  EDIT_ADDRESS: "Edit Address",
  UPDATE_EDIT_ADDRESS: "Update Current Address",
  EDIT_PERMANENT_ADDRESS: "Edit Permanent Address",
  UPDATE_PERMANENT_ADDRESS: "Update Permanent Address",
  UPDATE_ABFL_PL_OFFICE_ADRESS: "Update ABFL PL Office Address",
  EDIT_DOB: "Edit DOB",
  UPDATE_DOB: "Update DOB",
  EDIT_GENDER: "Edit Gender",
  LENDER_UPDATE_GENDER: "Update Gender",
  RUN_KYC_CHECKS: "Run KYC Checks",
  APPROVE_BUSINESS_DOCS: "Approve Business Documents",
  INITIATE_NEW_APPLICATION: "Initiate New Application",
  SEND_SESSION_LINK_TO_USER: "Send Session Link to Customer",
  REASSIGN_LEADS: "Reassign Leads",
  SKIP_BANK_CONNECT: "Skip Bank Connect",
  EXPIRE_USER: "Expire User",
  BYPASS_BRE: "Bypass BRE",
  REVERT_DISQUALIFICATION: "Revert Disqualification",
  RETRIGGER_DEVICE_API: "Retrigger Device API",
  SUBMIT_KYC: "Submit KYC",
  RESUBMIT_KYC: "Resubmit KYC",
  CREATE_TRANSACTIONS: "Create Transactions",
  RESOLVE_QUERY: "Resolve Query",
  CANCEL_TRANSACTION: "Cancel Transaction",
  MOVE_TO_PROCESSING: "Move to Processing",
  SPLIT_TRANSACTION: "Split Transaction",
  UPDATE_CL_TXN_DETAILS: "Update CL Txn Details",
  CHANGE_ACCOUNT_HOLDER_NAME: "Change Account Holder Name",
  GENERATE_EMANDATE_LINK: "Generate E-Mandate Link",
  GENERATE_EMANDATE_URL: "Generate E-mandate Url",
  REFRESH_BANK_STATEMENTS: "Refresh Bank Statements",
  DOWNLOAD_BANK_CONNECT_REPORT: "Download Bank Connect Report",
  DELETE_DOCS: "Delete Docs",
  UPLOAD_DOCS: "Upload Docs",
  UPLOAD_DOCUMENT: "Upload Document",
  ADD_DOCUMENTS: "Add Documents",
  EDIT_BUSINESS_DETAILS: "Edit Business Details",
  UPDATE_BUSINESS_DETAILS: "Update Business Details",
  EDIT_BUSINESS_ADDRESS: "Edit Business Address",
  UPDATE_BUSINESS_ADDRESS: "Update Business Address",
  DOWNLOAD_GSTIN: "Download GSTIN",
  CREATE_NEW_AGENT: "Create New Agent",
  BULK_CREATE_AGENTS: "Bulk Create Agents",
  BULK_REASSIGN_AGENTS: "Bulk Reassign Agents",
  EXPORT_LEAD_LEVEL_DATA_DUMP: "Export Lead Level Data Dump",
  SALES_DISPOSITION_REPORT: "Sales Disposition Report",
  EXPORT_REJECTION_REASON_DATA_DUMP: "Export Rejection Reason Data Dump",
  EXPORT_TRANSACTION_DATA_DUMP: "Export Transaction Data Dump",
  EXPORT_OD_APPLICATION_DATA_DUMP: "Export OD Application Data Dump",
  EXPORTN_COLLECTION_DATA_DUMP: "Export Collection Data Dump",
  EXPORT_APPLICATION_DATA_DUMP: "Export Application Data Dump",
  EXPORT_USER_DATA_DUMP: "Export User Data Dump",
  ONBOARDING_FUNNEL_REPORT: "Onboarding Funnel Report",
  DISQUALIFICATION_REPORT: "Disqualification Report",
  DOCUMENT_REPORT: "Document Report",
  LOAN_STATUS_REPORT: "Loan Status Report",
  FUNNEL_REPORT: "Funnel Report",
  INSURANCE_REPORT: "Insurance Report",
  EMPLOYMENT_REPORT: "Employment Report",
  CUSTOMER_USER_DATA_DUMP: "Custom User Data Dump",
  ENACH_MANDATE: "E-nach Mandate",
  CREATE_GROUP: "Create Group",
  ADD_GROUP_PERMISSION: "Add Group Permission",
  DELETE_GROUP_PERMISSION: "Delete Group Permission",
  DELETE_GROUP: "Delete Group",
  UPDATE_MASKING_LEVEL: "Update Masking Level",
  CREATE_ROLE: "Create Role",
  UPDATE_ROLE: "Update Role",
  DELETE_ROLE: "Delete Role",
  CREATE_USER: "Create User",
  DELETE_USER: "Delete User",
  ACTIVATE_USER: "Activate User",
  UPLOAD_DASHBOARD_MEDIA: "Upload",
  UPDATE_CREDITLINE_TRANSACTION_DETAILS: "Update Creditline Txn Details",
  UPDATE_CREDITLINE_TRANSACTION_STATUS: "Update Creditline Txn Status",
  UPDATE_KYC_DOC: "Update KYC Document",
  REFRESH_BANK_STATMENTS: "Refresh Bank Statements",
  UPDATE_WEBHOOK_URL: "Update Webhook URL",
  GET_WEBHOOK_URL: "Get Webhook URL",
  DELETE_DOCUMENTS: "Delete Documents",
  DEMOTE_USER_ADMIN_SETTINGS: "Demote User Admin Settings",
  PROMOTE_USER_TO_ADMIN_SETTINGS: "Promote User To Admin Settings",
  CREATE_DIRECT_TRANSACTION: "Create Direct Transaction",
  VALIDATE_GSTIN: "Validate GSTIN",
  VALIDATE_BANK_ACCOUNT: "Validate Bank Account",
  DUMMY_DOWNLOAD_KYC_DOCS: "Download KYC Docs",
  UPDATE_MFA: "Update MFA Status",
  ADD_OFFER_NEGOTIATION: "Add offer negotiation",
  CREATE_EMPLOYEE_OR_ORGANIZATION: "Create Employee / Organization",
  CREATE_COLLABORATOR: "Create Collaborator",
  DELETE_COLLABORATOR: "Delete Collaborator",
  LIST_COLLABORATOR: "List Collaborator",
  EDIT_EMPLOYEE_OR_ORGANIZATION: "Edit Employee / Organization",
  DEACTIVATE_EMPLOYEE_OR_ORGANIZATION: "Deactivate Employee / Organization",
  DELETE_AGENT: "Delete Agent",
  LIST_ORGANIZATION_HIERARCHY: "List Organization Hierarchy",
  GET_AGENT_DETAILS: "Get Agent Details",
  REASSIGN_MANAGER: "Reassign Manager",
  REACTIVATE_AGENT: "Reactivate Agent",
  BULK_REASSIGN_MANAGERS: "Bulk Reassign Managers",
  UPDATE_BUSINESS_INDUSTRY_DETAILS: "Update Business Industry Details",
  CANCEL_NACH: "Cancel NACH",
  RETRIGGER_COAPP_BUREAU: "Retrigger CoApp Bureau",
  DELTE_CO_APPLICANT: "Delete Co Applicant",
  UPDATE_PD_TASK: "Update PD Task",
  CREATE_PD_TASK: "Create PD Task",
  LENDER_UPDATE_ABFL_PL_EMPLOYER_NAME: "Update ABFL PL Employer Name",
  UPDATE_ABFL_PL_COMPANY_NAME: "Update ABFL PL Company Name",
  RETRIGGER_PENNY_DROP: "Re-Trigger Penny Drop",
  HIDE_FILTERS: "Hide Filters",
  SHOW_ONLY_INPUT_PREDICTORS: "Show Only Input Predictors",
  UPDATE_Udyam_Details: "Update Udyam Details",
  UPDATE_UAN_STATUS: "Update UAN Status"
} as const;

export const TAB_ACTIONS = {
  SCREENING_STATUS_DROPDOWN: "SCREENING_STATUS_DROPDOWN"
};

// "Create New Agent",
//     "Bulk Create Agents",
//     "Bulk Reassign Agents",
//     "Create Employee / Organization",
//     "Create Collaborator",
//     "Delete Collaborator",
//     "List Collaborator",
//     "Edit Employee / Organization",
//     "Deactivate Employee / Organization",
//     "List Managers",
//     "List Organization Hierarchy",
//     "Get Agent Details",
//     "Reassign Manager",
//     "Reactivate Agent",
//     "Bulk Reassign Managers"

export const SOURCE_ENTITY_IDS = {
  TDLBNPLID: {
    sourceEntityID: "99bf10ac-0247-4d7c-86d7-0d639bbdb6ff",
    programID: "ec075800-d51f-4864-90c5-f1d05a53ce15",
    programName: "DUAL_LIMIT_PAYLATER"
  }
};

export const ORG_IDS = {
  ABFL: "eabdf414-d3f3-4f1a-ad71-f01d59d9c05b",
  ABFL_PL: "65c5927f-5673-440e-a7be-e0b51e42c103",
  MUTHOOT: "9aad7c89-718d-4767-a6b3-f084a1833c47",
  PFL_EL: "db5fcba9-70cb-42b3-aaf1-d0afc0903e79",
  PFL_NEW: "7ae9ddeb-85d1-4dfa-a8c9-2662a3663c29",
  IIFL: "d83705ab-6bce-43a2-8b17-5ef7d9d460af",
  MFL_LAP: "2a00611d-fbe6-484b-a6ef-670769ceeea3",
  MFL: "148fa0b6-f63a-4938-ac69-79831e54200f",
  MONEY_CONTROL: "3079a023-0b62-46cc-ad17-da5b60a0751a",
  ABCD: "12824bf0-0ce8-4fbf-9528-0cf803da3d68",
  HDFC_PL: "066b53f4-e00f-46d0-a74d-eda3293b5f2a",
  JIO: "abc2d20e-b37b-4429-946c-80cbd43812a4",
  HFCL: "427e18bc-34e8-450f-b7a6-20c974375939",
  TVSCS: "b69631a3-36ee-4b80-8998-3ff78844f48d"
};

export const LENDER_IDs = {
  ABFLID: "c1a55e53-4701-49a1-923c-3cf32a66b5ec",
  IIFLID: "b46205ae-14f3-43ae-bedb-86d4d82df2f8",
  MUTHOOTID: "ad97435f-af0b-4bed-849e-1b309f943087",
  MFL: "8efd25fb-9c1f-4adc-90a8-7e2cc0b17775",
  ABFLPL: "da77e829-52c2-4b1f-9686-2d5bf04660ed",
  MFL_LAP: "0879bda2-39c7-4d6a-a55e-bb9f7b13389d",
  ABFL_CO_LENDING: "ebc32b84-1b56-4270-a390-9f384f095e5e",
  HERO_FINCORP: "6a5255c5-9fce-4654-8881-6c9c4efde9e8",
  HFCL: "6a5255c5-9fce-4654-8881-6c9c4efde9e8",
  TVSCS: "17a82cb1-0195-4865-9220-48d6b539ca2a"
};

export enum LENDER_NAMES {
  ABFLID = "ABFLID",
  IIFLID = "IIFLID",
  MUTHOOTID = "MUTHOOTID",
  MFL = "MFL",
  ABFLPL = "ABFLPL",
  MFL_LAP = "MFL_LAP",
  ABFL_CO_LENDING = "ABFL_CO_LENDING",
  HERO_FINCORP = "HERO_FINCORP",
  HFCL = "HFCL",
  TVSCS = "TVSCS"
}

export enum ORG_NAMES {
  ABFL = "ABFL",
  ABFL_PL = "ABFL_PL",
  MUTHOOT = "MUTHOOT",
  PFL = "PFL",
  IIFL = "IIFL",
  MFL_LAP = "MFL_LAP",
  MFL = "MFL",
  MONEY_CONTROL = "MONEY_CONTROL",
  ABCD = "ABCD",
  TVSCS = "TVSCS"
}

export const BUSINESS_LOAN = "business_loan";
export const PERSONAL_LOAN = "personal_loan";
export const CREDIT_LINE = "credit_line";
export const OVERDRAFT = "overdraft";
export const BUSINESS_LOAN_EMI = "business_loan_emi";
export const BUSINESS_LOAN_EDI = "business_loan_edi";

export const PAGE_CONFIG_LENDER = {
  [LENDER_IDs.MFL]: {
    global: {
      productTypes: [
        PERSONAL_LOAN,
        CREDIT_LINE,
        OVERDRAFT,
        BUSINESS_LOAN_EMI,
        BUSINESS_LOAN_EDI
      ],
      navbarProducts: {
        LOAN_APPLICATION: {
          name: "Loan Applications"
        }
      },
      isMFL: true
    },
    "Loan Applications Page": {
      showDocReviewFilter: true,
      filter: {
        schemes: true
      }
    },
    "Loan Application Underwriting Bureau Data Tab": {
      tabName: "Bureau Data"
    },
    "Loan Application Underwriting Bank Connect Tab": {
      tabName: "Bank Connect"
    },
    "Loan Application Underwriting GST Tab": {
      tabName: "GST"
    },
    "Loan Application Loan Offer Tab": {
      validators: "default",
      hideActions: "default"
    },
    "Loan Application Deviation Tab": {
      validators: "default",
      hideActions: "default"
    },
    "Loan Application Detail Page": {
      showDocumentReviewAction: true,
      tabs: {
        LOAN_TABS,
        CREDITLINE_TABS,
        BUSINESS_LOAN_TABS: [
          ...BUSINESS_LOAN_TABS,
          {
            name: "ALL DOCUMENTS"
          }
        ]
      },
      hideActions: "default",
      validators: "default",
      hideKeys: [
        "campaignType",
        "utmSource",
        "utmContent",
        "utmMedium",
        "utmCampaign"
      ],
      showKeys: ["assistedBy"],
      cancelApplication: "default",
      renderUIConfig: false
    },
    "Loan Application Application Form Tab": {
      hideKeys: ["riskArea"],
      hideFormFields: ["riskArea"],
      renderUIConfig: false
    },
    "Loan Application Collateral Details Tab": {
      renderUIConfig: false,
      hideKeys: [],
      hideFormFields: []
    },
    "Loan Application Business Details Tab": {
      hideKeys: [
        "businessNature",
        "industryType",
        "margin",
        "metadata",
        "riskArea",
        "aggregateExposure",
        "legalEntityIdentifier",
        "nearestBranch",
        "manuallyEntered"
      ],
      hideFormFields: [
        "natureOfBusiness",
        "industryType",
        "margin",
        "riskArea",
        "additionalBusinessAddress"
      ]
    },
    "Loan Application Bank Info Tab": {
      hideActions: "default",
      hideKeys: ["pennyDrop"]
    },
    "Reports Page": {
      showDocReviewFilter: true
    }
  }
};

export const PAGE_CONFIG = {
  default: {
    global: {
      productTypes: [PERSONAL_LOAN, BUSINESS_LOAN, CREDIT_LINE, OVERDRAFT],
      navbarProducts: {
        LOAN_APPLICATION: {
          name: "Loan Applications"
        }
      }
    },
    // [PAGES_LIST.LEAD_DETAILS_PAGE]: {
    //   showAPIStackActions: ["resumeJourney"],
    // },
    [PAGES_LIST.LEAD_DETAILS_TAB]: {
      hideKeys: [
        "campaignType", // abfl specific field
        "utmSource", // abfl specific field
        "utmContent", // abfl specific field
        "utmMedium", // abfl specific field
        "utmCampaign", // abfl specific field
        "loanAccountNumber", // pfl specific field
        "radiusFlagResult", // pfl specific field
        "radiusValueKms", // pfl specific field
        "distanceBlocking" // pfl specific field
      ]
    },
    [PAGES_LIST.LOAN_APPLICATION_DETAILS_PAGE]: {
      tabs: {
        LOAN_TABS,
        CREDITLINE_TABS,
        BUSINESS_LOAN_TABS: [...LOAN_TABS, ...BUSINESS_LOAN_TABS]
      },
      hideActions: "default" // check the visibility functions in the respective modules
      // showAPIStackActions: [
      //   "resumeJourney",
      //   "approveKYC",
      //   "rejectLoan",
      //   "authLetter",
      //   "signedAgreement",
      //   "statementOfAccounts",
      //   "unsignedAgreement",
      // ],
    },
    [PAGES_LIST.LOAN_APPLICATION_DETAILS_TAB]: {
      hideKeys: [
        "campaignType", // abfl specific field
        "utmSource", // abfl specific field
        "utmContent", // abfl specific field
        "utmMedium", // abfl specific field
        "utmCampaign", // abfl specific field
        "loanAccountNumber", // pfl specific field
        "radiusFlagResult", // pfl specific field
        "radiusValueKms", // pfl specific field
        "distanceBlocking" // pfl specific field
      ]
    },
    [PAGES_LIST.LOAN_APPLICATION_BUSINESS_DETAILS_TAB]: {
      hideKeys: ["businessNature"]
    }
  },
  [ORG_IDS.IIFL]: {
    global: {
      productTypes: [PERSONAL_LOAN, BUSINESS_LOAN, CREDIT_LINE, OVERDRAFT],
      navbarProducts: {
        LOAN_APPLICATION: {
          name: "Loan Applications"
        }
      }
    },
    // [PAGES_LIST.LEAD_DETAILS_PAGE]: {
    //   showAPIStackActions: ["resumeJourney"],
    // },
    [PAGES_LIST.LEAD_DETAILS_TAB]: {
      hideKeys: [
        "campaignType", // abfl specific field
        "utmSource", // abfl specific field
        "utmContent", // abfl specific field
        "utmMedium", // abfl specific field
        "utmCampaign", // abfl specific field
        "loanAccountNumber", // pfl specific field
        "radiusFlagResult", // pfl specific field
        "radiusValueKms", // pfl specific field
        "distanceBlocking" // pfl specific field
      ]
    },
    [PAGES_LIST.LOAN_APPLICATION_FORM_TAB]: {
      hideKeys: ["cifNumberIndividual", "alternateMobile"]
    },
    [PAGES_LIST.LOAN_APPLICATION_DETAILS_PAGE]: {
      tabs: {
        LOAN_TABS,
        CREDITLINE_TABS,
        BUSINESS_LOAN_TABS: [...LOAN_TABS, ...BUSINESS_LOAN_TABS]
      },
      hideActions: "default" // check the visibility functions in the respective modules
      // showAPIStackActions: [
      //   "resumeJourney",
      //   "approveKYC",
      //   "rejectLoan",
      //   "authLetter",
      //   "signedAgreement",
      //   "statementOfAccounts",
      //   "unsignedAgreement",
      // ],
    },
    [PAGES_LIST.LOAN_APPLICATION_DETAILS_TAB]: {
      hideKeys: [
        "campaignType", // abfl specific field
        "utmSource", // abfl specific field
        "utmContent", // abfl specific field
        "utmMedium", // abfl specific field
        "utmCampaign", // abfl specific field
        "loanAccountNumber", // pfl specific field
        "radiusFlagResult", // pfl specific field
        "radiusValueKms", // pfl specific field
        "distanceBlocking" // pfl specific field
      ]
    },
    [PAGES_LIST.LOAN_APPLICATION_BUSINESS_DETAILS_TAB]: {
      hideKeys: ["businessNature"]
    }
  },
  [ORG_IDS.MUTHOOT]: {
    global: {
      productTypes: [PERSONAL_LOAN, BUSINESS_LOAN, CREDIT_LINE, OVERDRAFT],
      navbarProducts: {
        LOAN_APPLICATION: {
          name: "Loan Applications"
        }
      },
      requiredBusinessDetailsFields: {
        businessPAN: false,
        constitution: false
      }
    },
    [PAGES_LIST.LEAD_DETAILS_TAB]: {
      hideKeys: [
        "campaignType", // abfl specific field
        "utmSource", // abfl specific field
        "utmContent", // abfl specific field
        "utmMedium", // abfl specific field
        "utmCampaign", // abfl specific field
        "loanAccountNumber", // pfl specific field
        "radiusFlagResult", // pfl specific field
        "radiusValueKms", // pfl specific field
        "distanceBlocking" // pfl specific field
      ]
    },
    [PAGES_LIST.LOAN_APPLICATION_FORM_TAB]: {
      hideKeys: ["cifNumberIndividual"]
    },
    [PAGES_LIST.LOAN_APPLICATION_DETAILS_PAGE]: {
      tabs: {
        LOAN_TABS,
        CREDITLINE_TABS,
        BUSINESS_LOAN_TABS: [...LOAN_TABS, ...BUSINESS_LOAN_TABS]
      },
      hideActions: "default" // check the visibility functions in the respective modules
    },
    [PAGES_LIST.LOAN_APPLICATION_DETAILS_TAB]: {
      hideKeys: [
        "campaignType", // abfl specific field
        "utmSource", // abfl specific field
        "utmContent", // abfl specific field
        "utmMedium", // abfl specific field
        "utmCampaign", // abfl specific field
        "loanAccountNumber", // pfl specific field
        "radiusFlagResult", // pfl specific field
        "radiusValueKms", // pfl specific field
        "distanceBlocking" // pfl specific field
      ]
    },
    [PAGES_LIST.LOAN_APPLICATION_BUSINESS_DETAILS_TAB]: {
      hideKeys: ["businessNature"]
    }
  },
  [ORG_IDS.ABFL]: {
    global: {
      productTypes: [BUSINESS_LOAN],
      navbarProducts: {
        LOAN_APPLICATION: {
          name: "Working Capital Term Loan"
        }
      },
      requiredBusinessDetailsFields: {
        businessPAN: false,
        constitution: false
      }
    },
    [PAGES_LIST.LEAD_DETAILS_TAB]: {
      hideKeys: [
        "cibil",
        "cibilStatus",
        "experian",
        "experianStatus",
        "fisScore"
      ],
      showKeys: [
        "campaignType", // abfl specific field
        "utmSource", // abfl specific field
        "utmContent", // abfl specific field
        "utmMedium", // abfl specific field
        "utmCampaign" // abfl specific field
      ]
    },
    [PAGES_LIST.LOAN_APPLICATIONS_LISTING_PAGE]: {
      filter: {
        taskStatus: true,
        workflowGroups: true
      }
    },
    [PAGES_LIST.LOAN_APPLICATION_DETAILS_TAB]: {
      hideKeys: ["cibil", "cibilStatus", "experian", "experianStatus", "fis"],
      showKeys: [
        "campaignType", // abfl specific field
        "utmSource", // abfl specific field
        "utmContent", // abfl specific field
        "utmMedium", // abfl specific field
        "utmCampaign" // abfl specific field
      ]
    },
    [PAGES_LIST.LOAN_APPLICATION_DETAILS_PAGE]: {
      tabs: {
        LOAN_TABS: [
          {
            name: "Details"
          },
          {
            name: "Application Form"
          },
          {
            name: "Underwriting"
          },
          {
            name: "Activity History"
          },
          {
            name: "Co-Applicants"
          },
          {
            name: "Directors"
          },
          {
            name: "Loan Offer"
          },
          {
            name: "KYC"
          },
          {
            name: "Additional Docs"
          },
          {
            name: "Workflow Timeline"
          },
          {
            name: "Manual Credit Review"
          },
          {
            name: "Loan Term Deviation"
          },
          {
            name: "Bank Info"
          },
          {
            name: "Partner Details"
          },
          {
            name: "Payments"
          },
          {
            name: "Deviation"
          },
          // {
          //   name: "Bank Statements",
          // },
          {
            name: "Notes"
          }
        ],
        CREDITLINE_TABS,
        BUSINESS_LOAN_TABS: [
          {
            name: "Details"
          },
          {
            name: "Application Form"
          },
          {
            name: "Underwriting"
          },
          {
            name: "Co-Applicants"
          },
          {
            name: "Directors"
          },
          {
            name: "Business Details"
          },
          {
            name: "Activity History"
          },
          {
            name: "Loan Offer"
          },
          {
            name: "KYC"
          },
          {
            name: "Additional Docs"
          },
          {
            name: "Workflow Timeline"
          },
          {
            name: "Manual Credit Review"
          },
          {
            name: "Loan Term Deviation"
          },
          {
            name: "Bank Info"
          },
          {
            name: "Partner Details"
          },
          {
            name: "Payments"
          },
          // {
          //   name: "Bank Statements",
          // },
          {
            name: "Notes"
          }
        ]
      },
      hideActions: "abfl" // check the visibility functions in the respective modules
    },
    [PAGES_LIST.LEAD_BUSINESS_DETAILS_TAB]: {
      hideKeys: ["businessPAN", "last12MonthsSale", "businessCategory"],
      hideFormFields: ["last12MonthsSale"]
    },
    [PAGES_LIST.LOAN_APPLICATION_BUSINESS_DETAILS_TAB]: {
      hideKeys: ["businessPAN", "last12MonthsSale", "businessCategory"],
      hideFormFields: ["last12MonthsSale"]
    },
    [PAGES_LIST.LOAN_APPLICATION_FORM_TAB]: {
      hideKeys: [
        "maritalStatus",
        "educationLevel",
        "fathersName",
        "permanentAddress",
        "mothersName",
        "houseOwnership",
        "registeredBusinessAddress",
        "loanPurpose",
        "alternateMobile"
      ]
    },
    [PAGES_LIST.LOAN_APPLICATION_LOAN_OFFER_TAB]: {
      disbursalAmountCalculationType: "custom"
    }
  },
  [ORG_IDS.ABFL_PL]: {
    global: {
      productTypes: [BUSINESS_LOAN],
      navbarProducts: {
        LOAN_APPLICATION: {
          name: "Loan Applications"
        }
      },
      requiredBusinessDetailsFields: {
        businessPAN: false,
        constitution: false
      }
    },
    [PAGES_LIST.LEAD_DETAILS_TAB]: {
      hideKeys: [
        "cibil",
        "cibilStatus",
        "experian",
        "experianStatus",
        "fisScore"
      ],
      showKeys: [
        "campaignType", // abfl specific field
        "utmSource", // abfl specific field
        "utmContent", // abfl specific field
        "utmMedium", // abfl specific field
        "utmCampaign" // abfl specific field
      ]
    },
    [PAGES_LIST.LOAN_APPLICATIONS_LISTING_PAGE]: {
      filter: {
        taskStatus: true,
        workflowGroups: true
      }
    },
    [PAGES_LIST.LOAN_APPLICATION_DETAILS_TAB]: {
      hideKeys: ["cibil", "cibilStatus", "experian", "experianStatus", "fis"],
      showKeys: [
        "campaignType", // abfl specific field
        "utmSource", // abfl specific field
        "utmContent", // abfl specific field
        "utmMedium", // abfl specific field
        "utmCampaign" // abfl specific field
      ]
    },
    [PAGES_LIST.LOAN_APPLICATION_DETAILS_PAGE]: {
      tabs: {
        LOAN_TABS: [
          {
            name: "Details"
          },
          {
            name: "Application Form"
          },
          {
            name: "Underwriting"
          },
          {
            name: "Activity History"
          },
          {
            name: "Co-Applicants"
          },
          {
            name: "Directors"
          },
          {
            name: "Loan Offer"
          },
          {
            name: "KYC"
          },
          {
            name: "Additional Docs"
          },
          {
            name: "Workflow Timeline"
          },
          {
            name: "Manual Credit Review"
          },
          {
            name: "Loan Term Deviation"
          },
          {
            name: "Bank Info"
          },
          {
            name: "Partner Details"
          },
          {
            name: "Payments"
          },
          {
            name: "Deviation"
          },
          // {
          //   name: "Bank Statements",
          // },
          {
            name: "Notes"
          }
        ],
        CREDITLINE_TABS,
        BUSINESS_LOAN_TABS: [
          {
            name: "Details"
          },
          {
            name: "Application Form"
          },
          {
            name: "Underwriting"
          },
          {
            name: "Co-Applicants"
          },
          {
            name: "Directors"
          },
          {
            name: "Business Details"
          },
          {
            name: "Activity History"
          },
          {
            name: "Loan Offer"
          },
          {
            name: "KYC"
          },
          {
            name: "Additional Docs"
          },
          {
            name: "Workflow Timeline"
          },
          {
            name: "Manual Credit Review"
          },
          {
            name: "Loan Term Deviation"
          },
          {
            name: "Bank Info"
          },
          {
            name: "Partner Details"
          },
          {
            name: "Payments"
          },
          {
            name: "Deviation"
          },
          // {
          //   name: "Bank Statements",
          // },
          {
            name: "Notes"
          }
        ]
      },
      hideActions: "abfl" // check the visibility functions in the respective modules
    },
    [PAGES_LIST.LEAD_BUSINESS_DETAILS_TAB]: {
      hideKeys: ["businessPAN", "last12MonthsSale", "businessCategory"],
      hideFormFields: ["last12MonthsSale"]
    },
    [PAGES_LIST.LOAN_APPLICATION_BUSINESS_DETAILS_TAB]: {
      hideKeys: ["businessPAN", "last12MonthsSale", "businessCategory"],
      hideFormFields: ["last12MonthsSale"]
    },
    [PAGES_LIST.LOAN_APPLICATION_FORM_TAB]: {
      hideKeys: [
        "maritalStatus",
        "educationLevel",
        "fathersName",
        "permanentAddress",
        "mothersName",
        "houseOwnership",
        "registeredBusinessAddress",
        "loanPurpose",
        "alternateMobile"
      ]
    },
    [PAGES_LIST.LOAN_APPLICATION_LOAN_OFFER_TAB]: {
      disbursalAmountCalculationType: "custom"
    }
  },
  [ORG_IDS.PFL_EL]: {
    global: {
      productTypes: [PERSONAL_LOAN, BUSINESS_LOAN, CREDIT_LINE, OVERDRAFT],
      navbarProducts: {
        LOAN_APPLICATION: {
          name: "Loan Applications"
        }
      }
    },
    [PAGES_LIST.LEAD_DETAILS_TAB]: {
      showKeys: [
        "radiusFlagResult", // pfl specific field
        "radiusValueKms", // pfl specific field
        "distanceBlocking" // pfl specific field
      ]
    },
    [PAGES_LIST.LOAN_APPLICATION_DETAILS_TAB]: {
      showKeys: [
        "loanAccountNumber", // pfl specific field
        "radiusFlagResult", // pfl specific field
        "radiusValueKms", // pfl specific field
        "distanceBlocking" // pfl specific field
      ]
    },
    [PAGES_LIST.LOAN_APPLICATION_DETAILS_PAGE]: {
      tabs: {
        LOAN_TABS,
        CREDITLINE_TABS,
        BUSINESS_LOAN_TABS: [...LOAN_TABS, ...BUSINESS_LOAN_TABS]
      },
      hideActions: "default" // check the visibility functions in the respective modules
    },
    [PAGES_LIST.LOAN_APPLICATION_BUSINESS_DETAILS_TAB]: {
      hideKeys: ["businessNature"]
    }
  },
  [ORG_IDS.MFL_LAP]: {
    global: {
      productTypes: [PERSONAL_LOAN, BUSINESS_LOAN, CREDIT_LINE, OVERDRAFT]
    },
    [PAGES_LIST.LOAN_APPLICATION_DETAILS_PAGE]: {
      tabs: {
        LOAN_TABS: [
          ...LOAN_TABS,
          {
            name: "Co-Applicants"
          }
        ]
      },
      hideActions: "default"
    },
    [PAGES_LIST.LOAN_APPLICATION_KYC_TAB]: {
      isMFL_LAP: true
    }
  },
  [ORG_IDS.MONEY_CONTROL]: {
    global: {
      isMoneyControl: true,
      showPreAgreementFilter: true,
      productTypes: [PERSONAL_LOAN, BUSINESS_LOAN, CREDIT_LINE, OVERDRAFT],
      navbarProducts: {
        LOAN_APPLICATION: {
          name: "Loan Applications"
        }
      }
    },
    // [PAGES_LIST.LEAD_DETAILS_PAGE]: {
    //   showAPIStackActions: ["resumeJourney"],
    // },
    [PAGES_LIST.LEAD_DETAILS_TAB]: {
      hideKeys: [
        "campaignType", // abfl specific field
        "utmSource", // abfl specific field
        "utmContent", // abfl specific field
        "utmMedium", // abfl specific field
        "utmCampaign", // abfl specific field
        "loanAccountNumber", // pfl specific field
        "radiusFlagResult", // pfl specific field
        "radiusValueKms", // pfl specific field
        "distanceBlocking" // pfl specific field
      ]
    },
    [PAGES_LIST.LOAN_APPLICATION_DETAILS_PAGE]: {
      tabs: {
        LOAN_TABS,
        CREDITLINE_TABS,
        BUSINESS_LOAN_TABS: [...LOAN_TABS, ...BUSINESS_LOAN_TABS]
      },
      hideActions: "default" // check the visibility functions in the respective modules
    },
    [PAGES_LIST.LOAN_APPLICATION_DETAILS_TAB]: {
      hideKeys: [
        "base",
        "campaignType", // abfl specific field
        "utmSource", // abfl specific field
        "utmContent", // abfl specific field
        "utmMedium", // abfl specific field
        "utmCampaign", // abfl specific field
        "loanAccountNumber", // pfl specific field
        "radiusFlagResult", // pfl specific field
        "radiusValueKms", // pfl specific field
        "distanceBlocking", // pfl specific field
        "assistedBy"
      ],
      showKeys: ["offerType", "offerAmount"]
    },
    [PAGES_LIST.LOAN_APPLICATION_BUSINESS_DETAILS_TAB]: {
      hideKeys: ["businessNature", "nearestBranch"]
    },
    [PAGES_LIST.LOAN_APPLICATION_FORM_TAB]: {
      hideKeys: [
        "modeOfSalary",
        "designation",
        "familyIncome",
        "employeesCount",
        "companyAge",
        "isPFDeducted",
        "branchCode",
        "branchName",
        "referralCode"
      ]
    }
  },
  [ORG_IDS.ABCD]: {
    global: {
      isABCD: true,
      showPreAgreementFilter: true,
      productTypes: [PERSONAL_LOAN, BUSINESS_LOAN, CREDIT_LINE, OVERDRAFT],
      navbarProducts: {
        LOAN_APPLICATION: {
          name: "Loan Applications"
        }
      }
    }
  }
};

export const MFA_STATUS = {
  DISABLED: 0,
  ENABLED: 1,
  AUTHENTICATED: 2,
  EMAIL_OTP_AUTHENTICATED: 3,
  MOBILE_OTP_AUTHENTICATED: 4
} as const;

export const MFA_STATUS_LABELS = {
  0: "Disabled",
  1: "Google MFA Enabled",
  2: "Google MFA Authenticated",
  3: "Email OTP Authenticated",
  4: "Mobile OTP Authenticated"
} as const;

// Auth mechanisms returned by /masterDashboard/getAuthType (PFL email-first login).
export const AUTH_TYPE = {
  SSO: "sso",
  EMAIL_PASSWORD_OTP: "email_password_otp"
} as const;

// change

// Dashboard Loan Status Text Mapping

// Status 0: "CANCELLED"
// Status 1: "FRESH_LOAN"

// Status 2 with:
// KYC Status -1 or 0: "LOAN_DETAILS_SUBMITTED"
// KYC Status 1: "KYC_PROCESSING"
// KYC Status 2: "KYC_SUCCESS"
// KYC Status 3: "KYC_REJECTED"
// KYC Status 7: "UNDER_REVIEW"

// Status 3: "LOAN_REJECTED"

// Status 4 with:
// KYC Status 2: "LOAN_APPROVED"
// KYC Status 5: "BANK_FAILED"
// KYC Status 6: "BANK_PROCESSING"

// Status 5 with:
// KYC Status 4: "BANK_ADDED"
// Status 6: "SIGN_AGREEMENT"
// Status 7: "DISBURSED"
// Status 8: "CLOSED"

export enum LoanStatus {
  KYC_PROCESSING = "KYC_PROCESSING",
  LOAN_DETAILS_SUBMITTED = "LOAN_DETAILS_SUBMITTED",
  KYC_REJECTED = "KYC_REJECTED",
  UNDER_REVIEW = "UNDER_REVIEW"
}

export const whiteLabelStyling = () => {
  const host = window?.location?.host || "";
  if (!host) return { whiteLabelStyle: {} }; // Return an empty object instead of `undefined` to prevent crashes
  const appID = host.includes("platform")
    ? "platform_dashboard"
    : "lending_dashboard";
  // Define domains that share the same configuration
  const domains = [
    "adityabirla-platform.finbox.in",
    "adityabirla-bl-lenders.finbox.in",
    "adityabirla-pl-lenders.finbox.in",
    "adityabirla-pl-platform.finbox.in",
    "adityabirla-colending-lenders.finbox.in"
  ];

  // Single shared configuration
  const sharedStyling = {
    theme: {
      color: {
        bg: "!bg-[#CA1F34]",
        darkbg: "!bg-[#B01C2D]",
        text: "!text-[#CA1F34]",
        lightbg: "!bg-[#FADFE2]",
        border: "!border-[#CA1F34]",
        borderDark: "!border-[#B01C2D]"
      },
      hover: {
        bg: "hover:!bg-[#FADFE2]",
        text: "hover:!text-[#CA1F34]",
        darkbg1: "hover:!bg-[#CA1F34]",
        focus: "focus:!border-[#CA1F34]"
      },
      after: {
        color1: "after:bg-[#CA1F34]"
      }
    },
    navbar: {
      logo: {
        img: "/abc.png",
        className: "md:w-[152px] md:h-auto w-10 h-10"
      },
      poweredBy: true
    },
    login: {
      hideFinbox: true,
      text: {
        title: "Sign in",
        subtitle: `Sign in to access your ${appID === "platform_dashboard" ? "Platform" : "Lender"} Dashboard`
      }
    },
    forgetPassword: {
      hideFinbox: true,
      text: {
        title: "Forgot Password",
        subtitle:
          "Please enter the email address to which the password reset link has to be sent"
      }
    },
    resetPassword: {
      text: {
        title: "Reset Password",
        subtitle: `Reset Password to access your ${appID === "platform_dashboard" ? "Platform" : "Lender"} Dashboard`
      }
    },
    input: {
      class: "focus:border-indigo-500 focus:outline-none focus:ring-indigo-500"
    }
  };

  const styling = Object.fromEntries(
    domains.map((domain) => [domain, sharedStyling])
  );

  const pflStylingData = Object.fromEntries(
    pflDomains.map((domain) => [domain, pflStyling])
  );

  const hfclStylingData = Object.fromEntries(
    hfclDomains.map((domain) => [domain, hfclStyling])
  );

  const result = pflDomains.includes(host)
    ? pflStylingData[host]
    : hfclDomains.includes(host)
      ? hfclStylingData[host]
      : styling[host];

  if (!result) return { whiteLabelStyle: {} };

  return { whiteLabelStyle: result || {} };
};

export const RELATION_TYPES: Array<{ name: string; value: string }> = [
  { name: "Other", value: "other" },
  { name: "Father", value: "father" },
  { name: "Mother", value: "mother" },
  { name: "Spouse", value: "spouse" },
  { name: "Sister", value: "sister" },
  { name: "Brother", value: "brother" },
  { name: "Uncle", value: "uncle" },
  { name: "Aunt", value: "aunt" },
  { name: "Coworker", value: "coworker" },
  { name: "Friend", value: "friend" }
];

export const isCOGroup = (rbacGroupName: string) => {
  return rbacGroupName === "CO Group";
};

export const isOPSGroup = (rbacGroupName: string) => {
  return rbacGroupName === "OPS Group";
};

export const isITAdminGroup = (rbacGroupName: string) => {
  return rbacGroupName === "IT ADMIN" || rbacGroupName === "IT ADMIN Group";
};

export const DOCUMENT_IDS = {
  BANK_STATEMENT: "43d70b37-b6bb-43bd-bf6c-37f0122efeec",
  FI_VERIFY: "6f3a9d92-4f1b-47c8-a8e3-2d7b5c9146fa",
  FCU_VERIFY: "6338e633-97cc-4366-9ca3-d0d82355bd0c",
  REVIEW: "6f3a9d92-4f1b-47c8-a8e3-2d7b5c9146fa",
  DECISION: "8a7b3c1d-4e5f-6a2b-9c8d-7e6f5a4b3c2d"
};

export const PLATFORM_DASHBOARD = "master_dashboard";
export const LENDER_DASHBOARD = "lender_dashboard";
export type ServiceType = typeof PLATFORM_DASHBOARD | typeof LENDER_DASHBOARD;

export const ruleColumns = [
  {
    name: "Rule",
    key: "rule",
    width: "275px",
    rowStyles: "whitespace-pre-line leading-7"
  },
  {
    name: "Value",
    key: "value",
    width: "275px",
    rowStyles: "whitespace-pre-line leading-7 break-words"
  },
  { name: "Details", key: "details", width: "120px" },
  { name: "Decision", key: "decision", width: "120px" }
];

export enum UIConfigComponentType {
  SIDEBAR = "sidebar",
  FORM = "form"
}

export const GST_MULTIPLIER = 1.18;
